import { axiosHelper } from 'Services/AxiosHelper';
import { MasterpassTokenModel } from 'Models';
import { masterpassTokenReqBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnGenerateTLVToken';

const onGenerateTLVToken = async (params: masterpassTokenReqBodyData): Promise<MasterpassTokenModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onGenerateTLVToken;
